import getNumericBalance from './getNumericBalance';

export enum CountryCodes {
  SPAIN = 'es-ES',
  PERU = 'es-PE',
  COLOMBIA = 'es-CO',
  PORTUGAL = 'pt-PT',
  ITALY = 'it-IT',
  FRANCE = 'fr-FR'
}

export enum CurrencyCodes {
  SPAIN = 'EUR',
  COLOMBIA = 'COP',
  PERU = 'PEN'
}

type signDisplayValues = 'auto' | 'never' | 'exceptZero' | 'always';

export const latamLocale = [CountryCodes.COLOMBIA, CountryCodes.PERU];

const CURRENCY = 'currency';

export const formatCurrency =
  (
    locale: CountryCodes = CountryCodes.SPAIN,
    currency: CurrencyCodes = CurrencyCodes.SPAIN,
    minimumFractionDigits = 2,
    signDisplay: signDisplayValues = 'auto'
  ) =>
  (value: number | string): string => {
    if (!value && value !== 0) {
      return '';
    }

    const numericValue = getNumericBalance(value);

    const formattedNumber = new Intl.NumberFormat(locale, {
      style: CURRENCY,
      currency,
      minimumFractionDigits,
      signDisplay
    }).format(numericValue);

    return formattedNumber;
  };

export const getCurrencySymbol = (
  locale: string = CountryCodes.SPAIN,
  currency: string = CurrencyCodes.SPAIN
): string =>
  (0)
    .toLocaleString(locale, {
      style: CURRENCY,
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
    .replace(/\d/g, '')
    .trim();

export const invertSign = (amount: number) => -1 * amount;
